import { IEditWatchContext } from './editWatchContext';

export enum EditWatchActionTypes {
	SET_ALL_DATA = 'SET_ALL_DATA',
	REFETCH_DATA = 'REFETCH_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	CHANGE_SERIAL_NUMBER = 'CHANGE_SERIAL_NUMBER',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
}

interface ISetAllData {
	type: EditWatchActionTypes.SET_ALL_DATA;
	payload: {
		watchID: IEditWatchContext['watchID'];
		serialNumber: IEditWatchContext['serialNumber'];
		IDSelectedCustomer: IEditWatchContext['IDSelectedCustomer'];
		IDSelectedRestaurant: IEditWatchContext['IDSelectedRestaurant'];
		isActive: IEditWatchContext['isActive'];
	};
}

interface IRefetchData {
	type: EditWatchActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditWatchContext['needRefetchData'];
	};
}

interface IChangeLoaderStatus {
	type: EditWatchActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: IEditWatchContext['isLoading'];
	};
}

interface IChangeSerialNumber {
	type: EditWatchActionTypes.CHANGE_SERIAL_NUMBER;
	payload: {
		serialNumber: IEditWatchContext['serialNumber'];
	};
}

interface ISetIDCustomer {
	type: EditWatchActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditWatchContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: EditWatchActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IEditWatchContext['IDSelectedRestaurant'];
	};
}

interface ISetDataForSubmit {
	type: EditWatchActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditWatchContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditWatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditWatchContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: EditWatchActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IEditWatchContext['errorResponseData'];
	};
}

export type TEditWatchAction =
	| ISetAllData
	| IRefetchData
	| IChangeLoaderStatus
	| IChangeSerialNumber
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo;
